




























































import {Component, Vue} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';
import DlgAnimalsNew from '@/modules/moderator/animals/_components/DlgAnimalsNew.vue';
import DlgAnimalsEdit from '@/modules/moderator/animals/_components/DlgAnimalsEdit.vue';
import S3Image from '@/components/S3Image.vue';
import DlgAnimalsDelete from '@/modules/moderator/animals/_components/DlgAnimalsDelete.vue';
import Loader from '@/components/Loader.vue';

@Component({
  components: {
    Loader,
    DlgAnimalsDelete,
    S3Image,
    DlgAnimalsEdit,
    DlgAnimalsNew,
  },
})
export default class AnimalsList extends Vue {
  private loading: boolean = false;
  @Action('moderator/animals/read') private readAnimals!: () => Promise<boolean>;
  @Getter('moderator/animals/all') private animals!: any[];

  private mounted() {
    this.loading = true;

    this.readAnimals()
      .then((success) => {
        if (success) {
          this.loading = false;
        } else {
          throw new Error('Some Error, handle it');
        }
      })
      .catch((err) => {
        this.loading = false;
      });
  }

  private getAnimalText(description: string) {
    return description ? description.replace(/\n/gm, '</br>') : '';
  }

  private getUrl(i: number) {
    return `https://loremflickr.com/563/957/dog/all?dude=${i}`;
  }

  private goToAnimal(animalId: string) {
    this.$router.push({name: 'ModeratorAnimal', params: {id: animalId}});
  }
}
